// extracted by mini-css-extract-plugin
export var bubble = "_2v-0";
export var container = "_2v-f";
export var contrastBorder = "_2v-g";
export var greyOut = "_2v-2";
export var initialsColor0 = "_2v-3";
export var initialsColor1 = "_2v-4";
export var initialsColor10 = "_2v-d";
export var initialsColor11 = "_2v-e";
export var initialsColor2 = "_2v-5";
export var initialsColor3 = "_2v-6";
export var initialsColor4 = "_2v-7";
export var initialsColor5 = "_2v-8";
export var initialsColor6 = "_2v-9";
export var initialsColor7 = "_2v-a";
export var initialsColor8 = "_2v-b";
export var initialsColor9 = "_2v-c";
export var initialsWrapper = "_2v-1";
export var large = "_2v-l";
export var medium = "_2v-k";
export var mediumSmall = "_2v-j";
export var mediumSmallMedium = "_2v-o";
export var micro = "_2v-h";
export var small = "_2v-i";
export var tiny = "_2v-n";
export var xTiny = "_2v-m";